import {
  ADD_ITEM_TO_CHECKOUT,
  CLEAR_CHECKOUT_CART,
  SEVEN_DAY_REFRESH_ID,
  THIRTY_DAY_REFRESH_ID,
  SINGLE_CREDIT_REPORT_BUNDLE,
  SINGLE_3B_CREDIT_REPORT_BUNDLE,
  // Used for WEBNXT-5039
  ADD_ITEM_TO_PRECHECKOUT,
  TURBO_1_WEEK_FREE_PLAN,
  TURBO_1_WEEK_FREE_PLAN_FULL_PRICE,
  CROA_PLAN,
  TURBO_NO_DISCOUNT_VAR6,
  PUBLIC_PREMIUM_TURBO_FREE_PLAN,
  TURBO_3BGATING_7_DAY_FREE_PLAN,
  TURBO_3BGATING_7_DAY_FREE_PLAN_TU,
  // Mobile services
  MOBILE_TURBO_3BGATING_7_DAY_FREE_PLAN,
  MOBILE_TURBO_3BGATING_7_DAY_FREE_PLAN_TU,
  MOBILE_IOS_PP_3BGATING_7_DAY_FREE_PLAN,
  MOBILE_IOS_PP_3BGATING_7_DAY_FREE_PLAN_TU,
  MOBILE_ANRDOID_PP_3BGATING_7_DAY_FREE_PLAN,
  MOBILE_ANRDOID_PP_3BGATING_7_DAY_FREE_PLAN_TU,
  //prem-3992
  WEB_999FT_4M3B,
  WEB_PP_3BGATING_7_DAY_FREE_TRIAL,
  WEB_PP_3BGATING_7_DAY_FREE_TRIAL_TU,
} from 'types/checkout.constants';

export const addItemToCheckout = (checkoutItemId, checkoutConfiguration) => {
  return {
    type: ADD_ITEM_TO_CHECKOUT,
    checkoutItemId,
    checkoutConfiguration,
  };
};

export const clearCheckoutCart = () => ({
  type: CLEAR_CHECKOUT_CART,
});

const pushToCheckout = history => {
  history.push('/checkout' + history.location.search);
};

const pushToPlusCheckout = (history, subscriptionLandingUrl) => {
  history.push(subscriptionLandingUrl + '/checkout' + history.location.search);
};
const pushToPlusReactivateCheckout = (history, subscriptionLandingUrl) => {
  history.push(
    subscriptionLandingUrl + '/reactivateCheckout' + history.location.search,
  );
};

const pushToPlusUpgradeCheckout = history => {
  history.push('/plus/upgradeCheckout' + history.location.search);
};

const pushToPlusUpgradeCheckoutHybrid = history => {
  history.push('/plus/upgradeCheckoutHybrid' + history.location.search);
};

const pushToPlusDirectCheckout = history => {
  history.push('/plus_directcheckout' + history.location.search);
};
const pushToPlusDirectCheckoutHybrid = history => {
  history.push('/plus_directcheckoutHybrid' + history.location.search);
};

export const pushToCheckoutWithConfig =
  (history, checkoutItemId, checkoutConfiguration) => dispatch => {
    dispatch(addItemToCheckout(checkoutItemId, checkoutConfiguration));
    pushToCheckout(history);
  };

export const pushToPlusCheckoutWithConfig =
  (history, checkoutItemId, checkoutConfiguration, subscriptionLandingUrl) =>
  dispatch => {
    dispatch(addItemToCheckout(checkoutItemId, checkoutConfiguration));
    pushToPlusCheckout(history, subscriptionLandingUrl);
  };
export const setupToPlusCheckoutWithConfig =
  (checkoutItemId, checkoutConfiguration) => dispatch => {
    dispatch(addItemToCheckout(checkoutItemId, checkoutConfiguration));
  };
export const pushToPlusReactivateCheckoutWithConfig =
  (history, checkoutItemId, checkoutConfiguration, subscriptionLandingUrl) =>
  dispatch => {
    dispatch(addItemToCheckout(checkoutItemId, checkoutConfiguration));
    pushToPlusReactivateCheckout(history, subscriptionLandingUrl);
  };

export const pushToPlusUpgradeCheckoutWithConfig =
  (history, checkoutItemId, checkoutConfiguration) => dispatch => {
    dispatch(addItemToCheckout(checkoutItemId, checkoutConfiguration));
    pushToPlusUpgradeCheckout(history);
  };

export const pushToPlusUpgradeCheckoutHybridWithConfig =
  (history, checkoutItemId, checkoutConfiguration) => dispatch => {
    dispatch(addItemToCheckout(checkoutItemId, checkoutConfiguration));
    pushToPlusUpgradeCheckoutHybrid(history);
  };

export const pushToPlusDirectCheckoutWithConfig =
  (history, checkoutItemId, checkoutConfiguration) => dispatch => {
    dispatch(addItemToCheckout(checkoutItemId, checkoutConfiguration));
    pushToPlusDirectCheckout(history);
  };

export const pushToPlusDirectCheckoutHybridWithConfig =
  (history, checkoutItemId, checkoutConfiguration) => dispatch => {
    dispatch(addItemToCheckout(checkoutItemId, checkoutConfiguration));
    pushToPlusDirectCheckoutHybrid(history);
  };

export const addNewPremiumPackage = history => dispatch => {
  dispatch(addItemToCheckout(WEB_999FT_4M3B));
  pushToCheckout(history);
};

export const addPremiumPlusPackage = history => dispatch => {
  dispatch(addItemToCheckout(WEB_PP_3BGATING_7_DAY_FREE_TRIAL));
  pushToCheckout(history);
};

export const add7DayRefreshToCheckout = history => dispatch => {
  dispatch(addItemToCheckout(SEVEN_DAY_REFRESH_ID));
  pushToCheckout(history);
};

export const add30DayRefreshToCheckout = history => dispatch => {
  dispatch(addItemToCheckout(THIRTY_DAY_REFRESH_ID));
  pushToCheckout(history);
};

export const add1BCreditReportPlanToCheckout = history => dispatch => {
  dispatch(addItemToCheckout(SINGLE_CREDIT_REPORT_BUNDLE));
  pushToCheckout(history);
};

export const add3BCreditReportPlanToCheckout = history => dispatch => {
  dispatch(addItemToCheckout(SINGLE_3B_CREDIT_REPORT_BUNDLE));
  pushToCheckout(history);
};

// Actions used for WEBNXT-5039

export const addSesameTurbo1WeekFreePlanToCheckout = history => dispatch => {
  dispatch(addItemToCheckout(TURBO_1_WEEK_FREE_PLAN));
  pushToCheckout(history, true);
};
export const addTurbo3BGating1WeekFreePlanToCheckout = history => dispatch => {
  dispatch(addItemToCheckout(TURBO_3BGATING_7_DAY_FREE_PLAN));
  pushToCheckout(history, true);
};

export const addTurbo3BGating1WeekFreePlanToCheckoutTU =
  history => dispatch => {
    dispatch(addItemToCheckout(TURBO_3BGATING_7_DAY_FREE_PLAN_TU));
    pushToCheckout(history, true);
  };

const redirectTocheckout = (history, applePayAvailable = null) => {
  let search = '';
  if (applePayAvailable === 'true') {
    search = '?applePayAvailable=true';
  } else {
    search = '?applePayAvailable=false';
  }

  history.push({
    pathname: '/checkout',
    state: history.location.pathname,
    search: search,
  });
};
export const addMobileTurbo3BGating1WeekFreePlanToCheckout =
  (history, applePayAvailable = null) =>
  dispatch => {
    dispatch(addItemToCheckout(MOBILE_TURBO_3BGATING_7_DAY_FREE_PLAN));
    redirectTocheckout(history, applePayAvailable);
  };
export const addMobileTurbo3BGating1WeekFreePlanToCheckoutTU =
  (history, applePayAvailable = null) =>
  dispatch => {
    dispatch(addItemToCheckout(MOBILE_TURBO_3BGATING_7_DAY_FREE_PLAN_TU));
    redirectTocheckout(history, applePayAvailable);
  };

export const addMobileIosPremiumPlan3BGating1WeekFreePlanToCheckout =
  (history, applePayAvailable = null) =>
  dispatch => {
    dispatch(addItemToCheckout(MOBILE_IOS_PP_3BGATING_7_DAY_FREE_PLAN));
    redirectTocheckout(history, applePayAvailable);
  };

export const addMobileIosPremiumPlan3BGating1WeekFreePlanToCheckoutTU =
  (history, applePayAvailable = null) =>
  dispatch => {
    dispatch(addItemToCheckout(MOBILE_IOS_PP_3BGATING_7_DAY_FREE_PLAN_TU));
    redirectTocheckout(history, applePayAvailable);
  };

export const addMobileAndroidPremiumPlan3BGating1WeekFreePlanToCheckout =
  (history, applePayAvailable = null) =>
  dispatch => {
    dispatch(addItemToCheckout(MOBILE_ANRDOID_PP_3BGATING_7_DAY_FREE_PLAN));
    redirectTocheckout(history, applePayAvailable);
  };
export const addMobileAndroidPremiumPlan3BGating1WeekFreePlanToCheckoutTU =
  (history, applePayAvailable = null) =>
  dispatch => {
    dispatch(addItemToCheckout(MOBILE_ANRDOID_PP_3BGATING_7_DAY_FREE_PLAN_TU));
    redirectTocheckout(history, applePayAvailable);
  };

export const addSesameTurbo1WeekFreePlanFullPriceToCheckout =
  history => dispatch => {
    dispatch(addItemToCheckout(TURBO_1_WEEK_FREE_PLAN_FULL_PRICE));
    pushToCheckout(history, true);
  };

const addItemToPrecheckout = precheckoutItemId => ({
  type: ADD_ITEM_TO_PRECHECKOUT,
  precheckoutItemId,
});

export const addSesameTurbo1WeekFreePlanToPrecheckout = history => dispatch => {
  dispatch(addItemToPrecheckout(TURBO_1_WEEK_FREE_PLAN));
  history.push('/precheckout');
};

export const addSesameTurbo1WeekFreePlanFullPriceToPrecheckout =
  history => dispatch => {
    dispatch(addItemToPrecheckout(TURBO_1_WEEK_FREE_PLAN_FULL_PRICE));
    history.push('/precheckout');
  };

export const addCROAPlanToPrecheckout = history => dispatch => {
  dispatch(addItemToPrecheckout(CROA_PLAN));
  history.push('/precheckout');
};

export const addCROAPlanToCheckout = history => dispatch => {
  dispatch(addItemToCheckout(CROA_PLAN));
  pushToCheckout(history, true);
};

export const addNoDiscountVar6Precheckout = history => dispatch => {
  dispatch(addItemToPrecheckout(TURBO_NO_DISCOUNT_VAR6));
  history.push('/precheckout');
};

export const addNoDiscountVar6ToCheckout = history => dispatch => {
  dispatch(addItemToCheckout(TURBO_NO_DISCOUNT_VAR6));
  pushToCheckout(history, true);
};

export const addPublicPremiumTurboFreePlanToCheckout = history => dispatch => {
  dispatch(addItemToCheckout(PUBLIC_PREMIUM_TURBO_FREE_PLAN));
  pushToCheckout(history, true);
};

export const addPublicPremiumPremiumPlusPlanToCheckout =
  history => dispatch => {
    dispatch(addItemToCheckout(WEB_PP_3BGATING_7_DAY_FREE_TRIAL_TU));
    pushToCheckout(history, true);
  };

export const dispatchPremiumMultiStackedToCheckout = planCode => dispatch => {
  dispatch(addItemToCheckout(planCode));
};

export const addPremiumMultiStackedToCheckout =
  (planCode, history) => dispatch => {
    dispatch(addItemToCheckout(planCode));
    history.push({
      pathname: '/checkout',
      state: history.location.pathname,
    });
  };
